export default "__VITE_ASSET__CsR1ReCi__"